module.exports = __webpack_public_path__ + "static/media/harshal_patil.c6c347cf.jpg";